const PageName = {
	Dashboard: 'Dashboard',
	User: {
		Main: 'UserInfo',
		Name: 'UserChangeName',
		Email: 'UserChangeEmail',
		Phone: 'UserChangePhone',
		Pw: 'UserChnagePw',
		NoticeSetting: 'NoticeSetting',
		Language: 'LngSetting',
	},
	Institution: {
		Main: 'InstitutionMain',
		Info: 'InstitutionInfo',
		Organization: 'InstitutionOrganization',
		Memberinfo: 'Memberinfo',
		Location: 'InstitutionLocation',
		StorageList: 'InstitutionStorageList',
		StorageInfo: 'InstitutionStorageInfo',
		Groupinfo: 'InstitutionGroupinfo',
		SubStorage: 'InstitutionSubStorage',
		StorageInventory: 'InstitutionStorageInventory',
	},
	Inventory: {
		List: 'Inventory',
		BundleList: 'InventoryBundleList',
		Detail: 'InventoryItemDetail',
		ItemCreate: 'InventoryItemCreate',
		ItemCreateCamera: 'InventoryItemCreateCamera',
		SearchProduct: 'InventorySearchProduct',
		BeingRegisteredList: 'InventoryBeingRegisteredList',
		AnalyzingItem: 'InventoryAnalyzingItem',
		DeleteDisposalList: 'InventoryDeleteDisposal',
		Expired: 'InventoryExpired',
		SafetyThreshold: 'InventorySafetyThreshold',
	},
	Management: {
		Menu: 'ManagementMenu',
	},
	Safety: {
		Main: 'Safety',
		Msds: 'SafetyMsds',
		MsdsDetail: 'SafetyMsdsDetail',
		HazardousMaterial: 'SafetyHazardousMaterial',
		HazardousMaterialList: 'SafetyHazardousMaterialList',
		SpecialManagement: 'SpecialManagement',
		SpecialManagementList: 'SpecialManagementList',
		HealthCheck: 'HealthCheck',
		HealthCheckupDetail: 'SafetyHealthCheckupDetail',
		HealthCheckupUsageHistory: 'SafetyHealthCheckupMaterial',
		HealthCheckupHistory: 'SafetyHealthCheckupHistory',
		DangerousStorage: 'SafetyDangerousStorage',
		DangerousStorageDetail: `SafetyDangerousStorageDetail`,
		DangerousStorageSub: 'SafetyDangerousStorageSub',
		Management: `SafetyManagement`,
		DangerousInventoryList: 'DangerousInventoryList',
		LawProductByGroup: 'LawProductByGroup',
		LawProductByGroupItem: 'LawProductByGroupItem',
	},
	Invite: {
		Receive: 'ReceiveInvitePage',
		Expire: 'LicenseExpirePage',
		Institute: 'InviteInstitutePage',
	},
	Auth: {
		EmailAuthentication: 'EmailAuthentication',
	},
	Cargo: {
		Main: 'Cargo',
		Do: 'CargoDo',
		Detail: 'CargoDetail',
	},
	GlobalFilter: 'GlobalFilter',
}

export default PageName
